import { combineReducers, configureStore } from '@reduxjs/toolkit'
import authSlice from './services/authSlice'
import dashboardSlice from "./services/dashboardSlice"
import subjectSlice from "./services/subjectSlice"
import subTopicSlice from "./services/subTopicSlice"
import questionSlice from "./services/questionSlice"
import studentSlice from "./services/studentSlice"
import fileSlice from "./services/fileUploadSlice"

const combineReducer = combineReducers({
    auth: authSlice,
    dashboard: dashboardSlice,
    subject:subjectSlice,
    subTopic:subTopicSlice,
    question:questionSlice,
    student:studentSlice,
    file: fileSlice,

})

const store = configureStore({
    reducer: combineReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(),
})

export default store